// extracted by mini-css-extract-plugin
module.exports = {"accordion__content":"Accordion_accordion__content__0UiVg","spin":"Accordion_spin__YW3JL","loader":"Accordion_loader__rsuux"};